module.exports = __webpack_public_path__ + "static/media/Danthabahgya3.b4e51da2.jpg";